module.exports = __webpack_public_path__ + "static/003-f21052effae51c4b43a84f7dfe18fc8e.jpg";